import { createFileRoute } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { AssessmentServicePlans } from "@/components/app/care-plans/assessment-service-plans";
import { SelfMedAssessments } from "@/components/app/self-med/self-med-assessments";
import { orpc } from "@/lib/orpc";
import { useCan, usePolicy } from "@/lib/policy";

export const Route = createFileRoute("/_authenticated/_care/residents/$residentId/plans")({
  component: PlansTab,
});

/** Two documents: the Assessment/Service Plan and, below it, the medication self-administration
 * assessment its level-of-care wording refers to. */
function PlansTab() {
  const { residentId } = Route.useParams();
  const { subject } = usePolicy();
  const { data: resident } = useSuspenseQuery(
    orpc.care.residents.get.queryOptions({ input: { residentId } }),
  );
  const canWrite = useCan("resident.clinical:update", resident.facilityId);

  return (
    <div>
      {/* The plans title their sections at h3; this is the tab's own level. */}
      <h2 className="sr-only">Care plans</h2>
      <AssessmentServicePlans
        residentId={residentId}
        facilityId={resident.facilityId}
        currentUserId={subject.userId}
        canWrite={canWrite}
      />
      <div className="mt-8 border-t pt-6">
        <SelfMedAssessments
          residentId={residentId}
          currentUserId={subject.userId}
          canWrite={canWrite}
        />
      </div>
    </div>
  );
}
